<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-clip-rotate-multiple"></ngx-spinner>
<div class="authentication-wrapper authentication-3">
    <div class="authentication-inner">

        <!-- Form container -->
        <div class="theme-bg-white d-flex col-lg-4 align-items-center p-5">
            <!-- Inner container -->
            <!-- Have to add `.d-flex` to control width via `.col-*` classes -->
            <div class="d-flex col-sm-7 col-md-5 col-lg-12 px-0 px-xl-4 mx-auto">
                <div class="w-100">

                    <h4 class="text-center text-lighter font-weight-normal mt-5 mb-0">Acesse sua conta</h4>

                    <!-- Form -->
                    <form class="my-5" (keyup.enter)="logar()">
                        <div class="form-group">
                            <label class="form-label">Login</label>
                            <input [(ngModel)]="login" name="email" type="text" class="form-control mb-2 ">
                            <span class="cor-danger font-weight-normal" *ngIf="loginNaoValido">*Esse email não
                                existe.</span>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Login</label>
                            <input [(ngModel)]="outro" name="email" type="text" class="form-control mb-2 ">                            
                        </div>
                        <div class="form-group">
                            <label class="form-label d-flex justify-content-between align-items-end">
                                <div>Senha</div>
                                <!-- <a href="javascript:void(0)" (click)="esqueceuSenha()" class="d-block small">Esqueceu sua senha ?</a> -->
                            </label>
                            <input [(ngModel)]="senha" name="password" type="password" class="form-control">
                        </div>
                        <div class="d-flex justify-content-between align-items-center m-0">
                            <button class="btn btn-primary" type="button" disabled *ngIf="logando">
                                <span class="spinner-border" role="status" aria-hidden="true"></span>
                                Carregando...
                            </button>
                            <button type="button" (click)="logar()" class="btn btn-primary"
                                *ngIf="!logando">Entrar</button>
                        </div>
                    </form>
                    <!-- / Form -->

                    <div class="text-center text-muted">
                        Esqueceu a senha ? <a href="javascript:void(0)" (click)="esqueceuSenha()">Clique aqui</a>
                    </div>

                </div>
            </div>
        </div>
        <!-- / Form container -->

    </div>
</div>
